import { FC, ReactNode } from 'react';

type Props = {
  label: string;
  children: ReactNode;
};

/**
 * Поле карточки сущности: подпись и значение (только для чтения).
 */
export const KmEntityField: FC<Props> = ({ label, children }) => (
  <div className="flex flex-col gap-1">
    <span className="text-sm text-muted-foreground">{label}</span>
    <span className="text-sm break-words">{children}</span>
  </div>
);
